import React, {useEffect, useState} from 'react';
import api from '../../api/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../provider/authProvider';
import Topbar from '../layout/Topbar';
import { getErrorMessage, logError } from '../../utils/errorHandler';


const Login = () => {
    const loginURL = `/login`;

    const location = useLocation();
    const flash = location.state?.flash;

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [msg, setMsg] = useState('');
    const [msgVerify, setMsgVerify] = useState('');

    const { setToken } = useAuth();
    const navigate = useNavigate();

    
    useEffect(() => {
        setMsg(flash)
    }, []);

    const Auth = async(e) =>{
        e.preventDefault();
        setMsg();
        setMsgVerify();
        try {
            const response = await api.post(loginURL,{
                email: email,
                password: password,
            });
            console.log(response);

            if(response.status === 202){
                console.log('verify email')
                setMsg(response.data.error)
                setMsgVerify('Verifikasi Sekarang');
            }else{
                setToken(response.data.token);
                navigate("/",{replace:true})
            }

        } catch (error) {
            logError('Login gagal:', error)
            setMsg(getErrorMessage(error, 'Login gagal. Periksa email dan password Anda.'))
        }
    }

    // email verify
    const goVerify = ()=>{
        const state = {
            state:{
                email:email
            }
        }
        navigate('/verify',state);
    }

    return (
        <div>
            <Topbar page={'login'}/>
            
                <div className="container p-5">
                  <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <form onSubmit={Auth} className="box">
                            <p className="has-text-centered">{msg}</p>
                            <p className='has-text-centered is-clickable has-text-primary' onClick={()=>goVerify()}>{msgVerify}</p>
                            <div className="field mt-5">
                                <label className="label">Email</label>
                                <div className="controls">
                                    <input type="email" className="input" placeholder='Email' 
                                    value={email} onChange={(e) => setEmail(e.target.value)}/>
                                </div>
                            </div>
                            <div className="field mt-5">
                                <label className="label">Password</label>
                                <div className="controls">
                                    <input type="password" className="input" placeholder='********' 
                                    value={password} onChange={(e) => setPassword(e.target.value)}/>
                                </div>
                            </div>
                            <div className="field mt-5">
                                <button className="button is-fullwidth has-background-primary-30 has-text-white">Login</button>
                            </div>
                            <p>Belum punya akun? <span className='has-text-primary is-clickable' onClick={()=>{navigate('/register')}}>Daftar</span></p>
                            <span className='has-text-primary is-clickable' onClick={()=>(navigate('/reset-password'))}>Lupa Password?</span>
                        </form>
                    </div>
                  </div>
                </div>
        </div>
    )
}

export default Login